import React from 'react';
import { Link } from "react-router-dom";

function changebg() {

    var num = Math.ceil(Math.random() * 2);
    document.body.background = "assets/img/loginBackground/loginback_" + num + ".jpg";
    document.body.style.backgroundSize = "cover";
  
  }

export default () => (

    <div className="container-fluid" onLoad={changebg()}>
        <div className="row d-flex align-items-center justify-content-center vh-100">
            <div
                className="col-10 col-md-7 col-lg-6 col-xl-4 t-sifreAlani"
                style={{ height: "auto" }}
            >
                <div className="row no-gutters d-flex justify-content-center px-4 w-100 pt-0 ">
                    {/* LOGO */}
                    <div className="col-12 d-flex justify-content-center">
                        <i className="t-icon-sad t-loginSifreAlBaslikIcon" />
                       
                    </div>
                    <br />
                    <div className="col-12 pt-0 pb-3 t-loadingMesaj">
                        Üzgünüz, Aradığınız Sayfayı Bulamadık.
                        <br />
                    </div>
                    <hr style={{ width: "100%" }} className="pt-3" />
                    <div className="col-12 pt-3 pb-3 pl-4 text-center">
                        <strong className="t-loginText ">Sayfa adresini kendiniz yazdıysanız yazım hatası yapıp yapmadığınızı kontrol edin.</strong>
                        <br /><br />
                        <strong className="t-loginText ">Eğer bu sayfaya başka bir linke tıklayarak ulaştıysanız, hatayı düzeltmemiz için lütfen bize haber verin.</strong>
                    </div>
                    <hr style={{ width: "100%" }} className="pt-3" />
                    <div className="col-auto pt-4 px-1">

                        <Link to="/Home/Dashboard" className="t-loginGeridonButton">
                            <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                            Geri Dön

                        </Link>
                    </div>
                    <div className="col-auto pt-4 px-1">

                        <Link to="/Home/Dashboard" className="t-loginGirisButton">Ana Sayfa
                            <i
                                className="t-icon-arrow-right2 pl-2"
                                style={{ fontSize: "14pt" }}
                            />
                        </Link>

                    </div>
                </div>
            </div>
        </div>
    </div>


);